/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiChannelItem } from '../../asyncapi/models/AaiChannelItem';
import { AaiDocument } from '../../asyncapi/models/AaiDocument';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';

/**
 * A command used to delete a channel in AsyncAPI document.
 * @author laurent.broudoux@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class DeleteChannelCommand extends AbstractCommand {
    public _channel : string;

    public _oldChannel : any;

    public constructor(channel? : any) {
        if(((typeof channel === 'string') || channel === null)) {
            let __args = arguments;
            super();
            if(this._channel===undefined) this._channel = null;
            if(this._oldChannel===undefined) this._oldChannel = null;
            if(this._channel===undefined) this._channel = null;
            if(this._oldChannel===undefined) this._oldChannel = null;
            (() => {
                this._channel = channel;
            })();
        } else if(channel === undefined) {
            let __args = arguments;
            super();
            if(this._channel===undefined) this._channel = null;
            if(this._oldChannel===undefined) this._oldChannel = null;
            if(this._channel===undefined) this._channel = null;
            if(this._oldChannel===undefined) this._oldChannel = null;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteChannelCommand] Executing for channel: %s", this._channel);
        let doc : AaiDocument = <AaiDocument>document;
        this._oldChannel = null;
        if(doc.channels == null || /* isEmpty */(Object.keys(doc.channels).length == 0)) {
            return;
        }
        this._oldChannel = Library.writeNode(/* remove */(map => { let deleted = doc.channels[this._channel];delete doc.channels[this._channel];return deleted;})(doc.channels));
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteChannelCommand] Reverting.");
        let doc : AaiDocument = <AaiDocument>document;
        if(this.isNullOrUndefined(this._oldChannel)) {
            return;
        }
        let channelItem : AaiChannelItem = doc.createChannelItem(this._channel);
        Library.readNode(this._oldChannel, channelItem);
        doc.addChannelItem(channelItem);
    }
}
DeleteChannelCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteChannelCommand";
DeleteChannelCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




